import { FC, ReactNode } from "react";

interface TeamTimelineItem {
    year: number;
    title: string;
    icon?: ReactNode;
    gapClass?: string;
    link?: string;
}

interface TeamTimelineProps {
    items: TeamTimelineItem[];
}

export const TeamTimeline: FC<TeamTimelineProps> = ({
    items
}) => {
    if (!items.length) {
        return null;
    }

    return (
        <div className="flex flex-row items-center text-sky-950 box-border">
            <div className="flex flex-row items-center relative" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                {items.map((i) => {
                    const spaceClass = i.gapClass ? i.gapClass : "w-11";
                    return (
                        <>
                            <div className="z-10 relative flex flex-col items-center justify-center uppercase">
                                <span>
                                    {i.year}
                                </span>
                                <a href={i.link} className="transition-all w-11 h-11 rounded-full bg-sky-950 hover:shadow active:scale-95">
                                    {i.icon}
                                </a>
                                <span className="font-bold text-xl">
                                    {i.title}
                                </span>
                            </div>
                            <div className={spaceClass} />
                        </>
                    );
                })}
                <div className="absolute top-1/2 left-5 right-3 border-0 border-b-2 border-solid border-sky-950" />
                <svg className="pt-[2px] pl-2 w-9 h-9 text-inherit" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m10 16 4-4-4-4" />
                </svg>
            </div>
            <span className="text-3xl font-bold uppercase-unset" style={{ fontFamily: 'Futura, sans-serif' }}>#TопиЗаРодину</span>
        </div>
    );
}